<template>
  <div class="main-container">
    <!-- 固定头部信息 -->
    <div class="header-section">
      <div class="back" @click="router.push('/application/index')">
        <a-button type="primary"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      </div>

      <div class="base-info">
        <div class="info-content">
          <div class="info-row">
            <div class="info-item">
              <span class="info-label">申请编号：</span>
              <span class="info-value">{{ details?.applicationNo || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">申请主体：</span>
              <span class="info-value">{{ details?.deptName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">申请车辆：</span>
              <span class="info-value">
                {{ details?.vin || '-' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">状态：</span>
              <span class="info-value">{{ getStatusView(details?.status)}}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 固定标签栏 -->
      <div class="qua-info-tab">
        <a-tabs default-active-key="1">
          <a-tab-pane tab="基本信息" key="1">
            <div class="tab-content-wrapper">
              <basic-info-tab :id="id" />
            </div>
          </a-tab-pane>
          <a-tab-pane v-if="details.categoryType === 'intelligent_connected_vehicle'" tab="智能网联车辆" key="2">
            <div class="tab-content-wrapper">
              <vehicle-tab
                  :id="id"
                  :vehicle-type-list="testVehicleTypeList"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane v-if="details.categoryType === 'autonomous_vehicle'" tab="低速无人驾驶车辆（装备）信息" key="2">
            <div class="tab-content-wrapper">
              <vehicle-tab2
                  :id="id"
                  :vehicle-type-list="testVehicleTypeList"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane tab="安全员信息" key="3">
            <div class="tab-content-wrapper">
              <security-user-tab :id="id" />
            </div>
          </a-tab-pane>
          <a-tab-pane tab="申请材料" key="4">
            <div class="tab-content-wrapper">
              <application-materials-tab
                  :id="id"
                  :user-task-permission-list="userTaskPermissionList"
                  @update-application-info="refreshApplicationInfo"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane tab="监管数据接入" key="5">
            <div class="tab-content-wrapper">
              <supervision-data-tab
                  :id="id"
                  :user-task-permission-list="userTaskPermissionList"
                  @update-application-info="refreshApplicationInfo"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane tab="专家组评估" key="6">
            <div class="tab-content-wrapper">
              <meeting-tab
                  :id="id"
                  :user-task-permission-list="userTaskPermissionList"
                  @update-application-info="refreshApplicationInfo"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane key="7">
            <template #tab>
              <span class="tab-with-badge">
                通知文书
                <span v-if="newNoticeCount > 0" class="badge">{{ newNoticeCount > 99 ? '99++' : newNoticeCount }}</span>
              </span>
            </template>
            <div class="tab-content-wrapper">
              <document-tab
                  :id="id"
                  @update-unread-count="updateUnreadCount"
              />
            </div>
          </a-tab-pane>
        </a-tabs>
        <div class="tab-footer">
          <div class="button-container">
            <div class="progress-tracker">
              <div v-if="materialFirstApprove" class="progress-item">
                <div class="progress-status" :class="getProgressStatusClass(materialFirstApprove)">
                    {{ getProgressStatusTitle(materialFirstApprove) }}
                  </div>
                <span class="progress-title">{{materialFirstApprove.nodeName}}</span>
              </div>
              <div v-if="materialFirstApprove" class="progress-line" :class="{ 'line-completed': materialFirstApprove.completed === 1 }"></div>
              <div v-if="superviseAccess" class="progress-item">
                <div class="progress-status" :class="getProgressStatusClass(superviseAccess)">
                  {{ getProgressStatusTitle(superviseAccess) }}
                </div>
                <span class="progress-title">{{ superviseAccess.nodeName }}</span>
              </div>
                <div v-if="superviseAccess" class="progress-line" :class="{ 'line-completed': superviseAccess.completed === 1 }"></div>
              <div v-if="expertGroupReview" class="progress-item">
                <div class="progress-status" :class="getProgressStatusClass(expertGroupReview)">
                  {{ getProgressStatusTitle(expertGroupReview) }}
                </div>
                <span class="progress-title">{{ expertGroupReview.nodeName }}</span>
              </div>
            </div>
            <div v-if="submitApproveTask && userTaskPermissionList.includes('submit_approve')"
                @click="submitApprove"
                :class="['submit-btn', { 'submit-btn-disabled': !canSubmit }]"
            >
              {{ submitApproveTask.completed === 0 ? submitApproveTask.nodeName : '已提交' }}
            </div>
            <div v-if="jointGroupApprove && userTaskPermissionList.includes('joint_group_approve')"
                 @click="showJointApproveModal"
                 :class="['submit-btn', { 'submit-btn-disabled': jointGroupApprove.active === 0 }]"
            >
              {{ jointGroupApprove.result === null ? jointGroupApprove.nodeName : jointGroupApprove.result === 1 ? '审核通过' : '审核未通过' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--审核模态框 -->
    <Modal
      v-model:open="jointApproveModalVisible"
      @ok="submitJointApprove"
      @cancel="jointApproveModalVisible = false"
      okText="确定"
      cancelText="取消"
      width="600px"
      :style="{ top: '20%' }"
    >
      <div class="total-review-section">
        <div class="review-form">
          <div class="form-item">
            <label class="form-label">审核结果：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input type="radio" name="jointReviewResult" value="1"
                       v-model="jointApproveData.result"
                       @change="jointApproveData.result = 1" />
                <span>通过</span>
              </label>
              <label class="radio-option">
                <input type="radio" name="jointReviewResult" value="0"
                       v-model="jointApproveData.result"
                       @change="jointApproveData.result = 0" />
                <span>不通过</span>
              </label>
            </div>
          </div>
          
          <!-- 审核意见/不通过原因 -->
          <div class="form-item">
            <label class="form-label">{{ jointReviewLabelText }}：</label>
            <textarea class="review-textarea" rows="3" 
                      :placeholder="jointReviewPlaceholderText"
                      v-model="jointApproveData.comment">
            </textarea>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script setup name="QualificationDetail">
import { ref, onMounted, computed, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import useUserStore from "@/store/modules/user";
const userStore = useUserStore();

import { getStatusView } from '@/utils/applicationUtils'
import { getApplicationById } from "@/api/application/testApplication";
import { getDocumentUnreceivedCount } from "@/api/application/documents";
import {
  getProcessTasksByApplicationId,
  getUserTaskPermissionByApplicationId,
  applicationApprove
} from "@/api/application/applicationProcessTask";
import { message, Modal, Form, Input, Radio } from 'ant-design-vue';
import { getVehicleTypeList } from "@/api/settings/vehicleType";

import BasicInfoTab from './components/BasicInfoTab.vue' //基本信息
import VehicleTab from './components/VehicleTab.vue' //智能网联车辆
import VehicleTab2 from './components/VehicleTab2.vue' //无人驾驶车辆
import SecurityUserTab from './components/SecurityUserTab.vue' //测试人员
import ApplicationMaterialsTab from './components/ApplicationMaterialsTab.vue' //申请材料
import SupervisionDeviceTab from './components/SupervisionDeviceTab.vue' //监管装置
import SupervisionDataTab from './components/SupervisionDataTab.vue' //监管数据接入
import MeetingTab from './components/MeetingTab.vue' //会议
import DocumentTab from './components/DocumentTab.vue' //通知文书

// 进度任务
const materialFirstApprove = ref(null); //材料初审
const superviseAccess = ref(null);     //监管数据接入
const expertGroupReview = ref(null)   //专家组评审
const submitApproveTask = ref(null)   //提交审核
const jointGroupApprove = ref(null)   //联系小组审核

const router = useRouter();
const route = useRoute();

const id = route.query.id;

const userTaskPermissionList = ref([]);
const testVehicleTypeList = ref([]);

// 最新通知数据数量
const newNoticeCount = ref(0);

const getProgressStatusClass = (node) => {
  if (node.completed === 0 && node.active === 0){
    return 'status-pending'
  }
  if (node.active === 1){
    return 'status-processing'
  }
  if (node.completed === 1 && node.result === 1){
    return 'status-completed'
  }
  if (node.completed === 1 && node.result === 0){
    return 'status-failed'
  }
  return 'status-pending'
}

const getProgressStatusTitle = (node) => {
  if (node.completed === 0 && node.active === 0){
    return '待进行'
  }
  if (node.active === 1){
    return '进行中'
  }
  if (node.completed === 1 && node.result === 1){
    return '已完成'
  }
  if (node.completed === 1 && node.result === 0){
    return '未通过'
  }
  return '待进行'
}

// 提交按钮状态
const canSubmit = computed(() => {
  return submitApproveTask.value?.completed === 0 && jointGroupApprove.value?.completed === 0;
});

// 更新待查看通知数量
const updateUnreadCount = async (count) => {
  newNoticeCount.value = count || 0;
  getDocumentUnreceivedCount(id).then(res => {
    if (res.code === 200){
      newNoticeCount.value = res.data;
    }else {
      newNoticeCount.value = 0;
    }
  })
}

//更新(申请信息，流程状态栏)
const refreshApplicationInfo = async () => {
  await getApplicationInfo();
  await getProcessTaskList();
}

// 获取详情
let details = ref({
  id: '',
  categoryType: '',
  categoryName: '',
  deptName: '',
  vin: '',
  vehicleType: '',
  createTime: '',
  status: ''
});

const getApplicationInfo = async () => {
  await getApplicationById(id).then((res) => {
    details.value = res.data;
  });
}

//提交联席小组审核
const submitApprove = () => {

  if (!canSubmit.value) {
    return;
  }
  const submitData = {
    applicationId: id,
    funcCode: 'submit_approve',
    result: 1
  }
  applicationApprove(submitData).then(res => {
    console.log('接口调用结果:', res);
    if (res.code === 200){
      refreshApplicationInfo()
    }
  }).catch(error => {
    console.error('接口调用失败:', error);
  })
};

// 联席小组审核弹框
const jointApproveModalVisible = ref(false);
const jointApproveData = reactive({
  result: undefined, // 1: 通过, 0: 不通过
  comment: ''
});

// 计算属性用于标签文本
const jointReviewLabelText = computed(() => {
  return jointApproveData.result === 1 ? '审核意见' : '不通过原因';
});

// 计算属性用于占位符文本
const jointReviewPlaceholderText = computed(() => {
  return jointApproveData.result === 1 ? '请输入审核意见（可选）' : '请输入不通过原因';
});

// 显示联席小组审核弹框
const showJointApproveModal = () => {
  // 重置表单
  jointApproveData.result = undefined;
  jointApproveData.comment = '';
  jointApproveModalVisible.value = true;
};

// 提交联席小组审核
const submitJointApprove = () => {
  // 验证审核结果
  if (jointApproveData.result === undefined) {
    message.warning('请选择审核结果');
    return;
  }
  
  // 验证不通过时的原因
  if (jointApproveData.result === 0 && !jointApproveData.comment.trim()) {
    message.warning('不通过时必须填写不通过原因');
    return;
  }
  
  const submitData = {
    applicationId: id,
    funcCode: 'joint_group_approve',
    result: jointApproveData.result,
    comment: jointApproveData.comment
  };
  
  applicationApprove(submitData).then(res => {
    console.log('接口调用结果:', res);
    if (res.code === 200){
      jointApproveModalVisible.value = false;
      refreshApplicationInfo();
      message.success('审核提交成功');
    } else {
      message.error('审核提交失败');
    }
  }).catch(error => {
    console.error('接口调用失败:', error);
    message.error('审核提交失败');
  });
}

const getProcessTaskList = async () => {
  await getProcessTasksByApplicationId(id).then(res => {
    if (res.code === 200){
      // 遍历所有任务节点
      const processTasks = res.data;
      
      // 处理所有节点和子节点的函数
      const processNodes = (nodes) => {
        nodes.forEach(node => {
          // 根据节点名称匹配并赋值
          switch (node.funcCode) {
            case 'material_first_approve':
              materialFirstApprove.value = node;
              break;
            case 'supervise_access':
              superviseAccess.value = node;
              break;
            case 'expert_group_review':
              expertGroupReview.value = node;
              break;
            case 'submit_approve':
              submitApproveTask.value = node;
              break;
            case 'joint_group_approve':
              jointGroupApprove.value = node;
              break;
          }
          
          // 递归处理子节点
          if (node.children && node.children.length > 0) {
            processNodes(node.children);
          }
        });
      };
      // 处理返回的任务列表
      processNodes(processTasks);
    }
  })
}

//获取用户任务的审批权限数据
const getUserTaskPermission = async () => {
  await getUserTaskPermissionByApplicationId(id).then(res => {
    if (res.code === 200 && res.data) {
      userTaskPermissionList.value = Array.isArray(res.data) ? res.data : []
    }
  })
}

const fetchVehicleTypeList = async () => {

  try {

    let params = {};
    const response = await getVehicleTypeList(params);
    if (response.code === 200 && response.data) {
      testVehicleTypeList.value = response.data;
    } else {
      message.error('获取车辆类型列表失败');
    }
  } catch (error) {
    console.error('查询车辆类型列表时出错:', error);
  }
}

onMounted(async () => {
  await getApplicationInfo();
  await updateUnreadCount(0);
  await getProcessTaskList();
  await getUserTaskPermission();
  await fetchVehicleTypeList();
});
</script>
<style lang="less" scoped>
.main-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;
}

.header-section {
  flex-shrink: 0;
  padding: 20px 20px 0 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.qua-info-tab {
  margin-top: 20px;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  z-index: 5;

  /* 使用::v-deep穿透选择器修改标签样式 */
  ::v-deep .ant-tabs-tab {
    font-size: 16px !important;
    padding: 5px 20px !important;
  }
}

.tab-content-wrapper {
  height: calc(100vh - 280px);
  overflow-y: auto;
  padding-bottom: 20px;
}

/* 自定义滚动条样式 */
.tab-content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.tab-content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.tab-content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.tab-content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.footer {
  flex-shrink: 0;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid #f0f0f0;
  background-color: #ffffff;
}


.base-info {
  padding: 0 20px;
  margin: 20px 0;
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 16px;
}

.info-content {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  border: 1px solid #f0f0f0;
}

.info-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.info-label {
  font-size: 16px;
  color: #636d7b;
  margin-right: 8px;
  min-width: 80px;
}

.info-value {
  font-size: 16px;
  color: #1d2129;
}

.file_text {
  width: 825px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #636d7b;
  padding: 0 0 0 66px;

  .file_icon {
    font-size: 18px;
    color: rgba(24, 111, 242, 1);
  }
}

.border {
  width: 800px;
  border-bottom: 1px solid #d9e5f4;
  margin: 11px 0 0 49px;
}

.footer_file {
  width: 516px;
  height: 158px;
  background: rgba(246, 248, 250, 1);
  margin: 58px auto 85px auto;
  text-align: center;
  padding: 16px 0 24px 0;

  .tit {
    margin-bottom: 8px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #636d7b;
  }

  .file_bg {
    width: 100px;
    height: 32px;
    line-height: 32px;
    margin-top: 8px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #636d7b;
    cursor: pointer;
  }
}

.footer {
  text-align: center;
}

.ml61 {
  margin-left: 61px;
}

a {
  color: rgba(30, 142, 242, 1);
}

.ml16 {
  margin-left: 16px;
}

.mb16 {
  margin-bottom: 16px;
}

.mt22 {
  margin-top: 22px;
}

.mb18 {
  margin-bottom: 18px;
}

.mr16 {
  margin-right: 16px;
}

/deep/.ant-radio-wrapper {
  margin-top: 10px;
}
/* 通知文书tab徽标样式 */
.tab-with-badge {
  position: relative;
  padding-right: 6px;
}

.badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: #ff4d4f;
  color: white;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  padding: 0 4px;
  box-shadow: 0 0 0 1px #fff;
}

/* Tab底部固定按钮区域 */
.tab-footer {
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  background-color: #ffffff;
  position: sticky;
  bottom: 0;
  z-index: 4;
}

/* 按钮容器居右 */
.button-container {
  display: flex;
  margin-left: auto;
  height: 100%;
  align-items: center;
}

/* 自定义提交按钮样式 */
.submit-btn {
  height: calc(100% - 16px);
  min-height: 40px;
  min-width: 120px;
  font-size: 18px;
  font-weight: 400;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  padding: 0 15px;
}

.submit-btn:hover {
  background-color: #40a9ff;
}

/* 禁用状态按钮样式 */
.submit-btn-disabled {
  background-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}

.submit-btn-disabled:hover {
  background-color: #d9d9d9;
}

/* 进度跟踪组件样式 */
.progress-tracker {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 进度连接线样式 */
.progress-line {
  width: 40px;
  height: 2px;
  background-color: #d9d9d9;
  margin: 0 12px;
}

/* 已完成的连接线样式 */
.line-completed {
  background-color: #52c41a;
}

.progress-title {
  font-size: 16px;
  color: #636d7b;
  font-weight: 400;
}

.progress-status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  font-weight: 500;
}

.status-pending {
  background-color: #f5f5f5;
  color: #636d7b;
}

.status-processing {
  background-color: #e6f7ff;
  color: #1890ff;
}

.status-completed {
  background-color: #f6ffed;
  color: #52c41a;
}

.status-failed {
  background-color: #fff2f0;
  color: #ff4d4f;
}

/* 禁用原因文字样式 - 保留以备后用 */
.disable-reason {
  font-size: 14px;
  color: #ff4d4f;
  display: flex;
  align-items: center;
}

.left-reason {
  margin-right: 16px;
}

.right-reason {
  margin-left: 16px;
}

/* 审核弹框样式 */
.total-review-section {
  padding: 10px 0;
}

.review-form {
  margin: 0 auto;
  max-width: 600px;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
  width: 100px;
  text-align: right;
}

.radio-group {
  display: inline-block;
}

.radio-option {
  margin-right: 30px;
  cursor: pointer;
}

.radio-option input[type="radio"] {
  margin-right: 8px;
}

.review-textarea {
  width: 400px;
  height: 120px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
  font-size: 14px;
  transition: border-color 0.2s;
}

.review-textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
</style>
